import {
  createOffsetPaginatedSchema,
  type CreateUserRequest,
  type OffsetPaginated,
  type UpdateUserRequest,
  type UserDto,
  UserDtoSchema,
  type UserListQuery,
} from '@ctms/contracts';

import { apiClient } from '../../api/client.js';
import { API_PATHS } from '../../api/paths.js';

const UserListResponseSchema = createOffsetPaginatedSchema(UserDtoSchema);

export const usersApi = {
  async listUsers(query: UserListQuery): Promise<OffsetPaginated<UserDto>> {
    const searchParams = new URLSearchParams();
    if (query.page) searchParams.set('page', String(query.page));
    if (query.limit) searchParams.set('limit', String(query.limit));
    if (query.status) searchParams.set('status', query.status);
    if (query.role) searchParams.set('role', query.role);
    if (query.search && query.search.trim().length > 0) {
      searchParams.set('search', query.search.trim());
    }

    const raw: unknown = await apiClient
      .get(API_PATHS.users.list, { searchParams })
      .json();
    return UserListResponseSchema.parse(raw);
  },

  async createUser(request: CreateUserRequest): Promise<UserDto> {
    const raw: unknown = await apiClient
      .post(API_PATHS.users.create, { json: request })
      .json();
    return UserDtoSchema.parse(raw);
  },

  async updateUser(id: number, request: UpdateUserRequest): Promise<UserDto> {
    const raw: unknown = await apiClient
      .patch(API_PATHS.users.byId(id), { json: request })
      .json();
    return UserDtoSchema.parse(raw);
  },
};
